import React, { FC } from 'react';
import {
    LinearProgress as LinearProgressBase,
    LinearProgressProps as LinearProgressPropsBase,
    linearProgressClasses,
} from '@mui/material';

import { PaletteColor } from '../../palette';


export type LinearProgressProps = Omit<LinearProgressPropsBase, 'color'> & {
    color?: PaletteColor;
}

export const LinearProgress: FC<LinearProgressProps> = ({ sx, color, ...props }) => (
    <LinearProgressBase
        {...props}
        sx={[({ spacing, palette }) => ({
            height: spacing(1),
            borderRadius: 99,
            [`.${linearProgressClasses.bar}`]: {
                borderRadius: 99,
                backgroundColor: color,
            },
            [`.${linearProgressClasses.colorPrimary}`]: {
                backgroundColor: palette.grayscale.shade60,
            },
        }),
        ...Array.isArray(sx) ? sx : [sx]]}
    />
);
